module.exports = __webpack_public_path__ + "media/images/icons/arrow_right-a32b6c425291ca29b87f1f381b4bf558.svg";